import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subject } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import { BaseService } from '../../services/base.service';
import { NotificationService } from '../../services/notifications.service';
import { activeTranslations } from '../../enum/constants';

@Component({
  templateUrl: './single-auth.component.html',
  styleUrls: ['./single-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SingleAuthComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly keycloakService: KeycloakService,
    private readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
  ) {}

  async ngOnInit() {
    const token = this.activatedRoute.snapshot.params['token'];
    const refreshToken = this.activatedRoute.snapshot.params['r_token'];
    const keycloakOptions = {
      config: { ...environment.keycloak },
      initOptions: {
        checkLoginIframe: false,
        token: token,
        refreshToken: refreshToken,
      },
    };
    try {
      const isInitialized = await this.keycloakService.init(keycloakOptions);

      if (!isInitialized) {
        // this.router.navigate(['/crm']);
        return;
      }

      const token = this.keycloakService.getKeycloakInstance().token as string;
      const refreshToken = this.keycloakService.getKeycloakInstance().refreshToken as string;

      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      const profile = await firstValueFrom(this.baseService.getProfile());
      if (!profile?.phone) {
        await this.router.navigate(['/additional']);
        return;
      }

      this.router.navigate(['/crm']);
    } catch {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  click() {
    this.router.navigate(['/login']);
    this.notificationService.showError(
      activeTranslations.notifications_texts.error.error,
      activeTranslations.notifications_texts.error.something_went_wrong_2,
    );
  }
}
